<template>
  <div class="body-wrapper">
    <Header :title="'Reports'" />
    <div class="body-container">
      <div class="tab-container">
        <ul class="tabs">
          <li 
            :class="{'selected': selectedTab === 'pending'}"
            @click="changeTab('pending')">
              NEW REPORTS
          </li>
          <li 
            :class="{'selected': selectedTab === 'ignored'}"
            @click="changeTab('ignored')">
              IGNORED
          </li>
          <li 
            :class="{'selected': selectedTab === 'deleted'}"
            @click="changeTab('deleted')">
              DELETED
          </li>
          <li 
            :class="{'selected': selectedTab === 'banned'}"
            @click="changeTab('banned')">
              BANNED
          </li>
        </ul>
        <div class="tab-body">
          <div class="tab" v-if="selectedTab === 'pending'">
            <DataTable 
              url="/v1/manage_reports"
              :fields="fields"
              :extraParams="getExtraParams('pending')"     
              @details-clicked="detailsClicked" />
          </div>
          <div class="tab" v-if="selectedTab === 'ignored'">
            <DataTable 
              url="/v1/manage_reports"
              :fields="fields"
              :extraParams="getExtraParams('ignored')"     
              @details-clicked="detailsClicked" />
          </div>
          <div class="tab" v-if="selectedTab === 'deleted'">
            <DataTable 
              url="/v1/manage_reports"
              :fields="fields"
              :extraParams="getExtraParams('deleted')"     
              @details-clicked="detailsClicked" />
          </div>
          <div class="tab" v-if="selectedTab === 'banned'">
            <DataTable 
              url="/v1/manage_reports"
              :fields="fields"
              :extraParams="getExtraParams('banned')"     
              @details-clicked="detailsClicked" />
          </div>
        </div>
      </div>
    </div>

    <ReportDetailModal
      v-if="viewReportDetails"/>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import DataTable from '../components/table/DataTable.vue';
import { getFeedback } from '@/api/requests';
import { formatDateTime } from '@/utils'
import ReportDetailModal from '../components/modals/ReportDetailModal.vue';

export default {
  name: 'Reports',

  components: {
    Header,
    DataTable,
    ReportDetailModal,
  },

  data() {
    return {
      selectedTab: 'pending',
    };
  },

  methods: {
    loadFeedback() {
      getFeedback().then(response => {
        this.feedback.push(...response.data);
      }).catch(() => {
        // TODO errors
      });
    },

    detailsClicked(value) {
      if (value['type'] === 'user') {
        this.$router.push({ name: 'UserReports', params: { userId: value.data.user.id } })
      } else {
        this.$store.dispatch('reports/reportClicked', value.data);
      }
    },

    changeTab(tab) {
      this.selectedTab = tab;
    },

    getExtraParams(type) {
      return {
        type
      };
    },
  },

  computed: {
    fields() {
      return [
        {
          name: 'report-id-slot',
          title: 'Report ID',
        },
        {
          name: 'report-count-slot',
          title: 'Count',
          sortField: 'total_count'
        },
        {
          name: "report-user-slot",
          title: 'User Reported',
          width: '15%'
        },
        {
          name: "report-by-slot",
          title: 'Reported By',
          width: '15%'
        },
        {
          name: 'report-reasons-slot',
          title: 'Report Type',
        },
        {
          name: 'item_type',
          title: 'Category',
          sortField: 'item_type'
        },
        {
          name: 'created_at',
          title: 'Date',
          sortField: 'created_at',
          formatter: formatDateTime
        },
        {
          name: 'resolution',
          title: 'Outcome',
          sortField: 'resolution',
        },
      ]
    },

    apiUrl() {
      return apiUrl();
    },

    viewReportDetails: {
      get () {
        return this.$store.state.reports.viewReportDetails
      },
      set (value) {
        this.$store.commit('users/updateAttribute', {value: value, type: 'viewReportDetails'})
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.body-container {
  height: calc(100% - 60px);

  .container {
    height: calc(100% - 60px);
    border: 1px solid $sec6;
    margin-bottom: $spacing-base;
  }
  .container-header {
    padding: $spacing-base;
    background: $sec7;
    border-bottom: 1px solid $sec6;
    display: flex;
    flex-direction: row;

    h3 {
      padding: 0;
      margin: 0;
      flex: 1;
      font-weight: normal;
      font-size: 1em;
      color: $sec2;
      line-height: 25px;
    }

    .report-actions {
      button {
        margin-left: $spacing-small;
      }
    }
  }
  .container-body {
    height: calc(100% - 44px);
    overflow-y: scroll;
  }
}

.tab-container {
  padding: $spacing-base;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    height: 28px;
    margin-bottom: $spacing-base;
    
    li {
      float: left;
      padding-left: $spacing-large;
      padding-right: $spacing-large;
      padding-bottom: $spacing-small;
      border-bottom: 3px solid $sec1;
      color: $sec1;
      font-weight: bold;
      font-size: $font-size-base;
      user-select: none;
      cursor: pointer;
    }

    .selected {
      color: $blue;
      border-color: $blue;
    }
  }

  .tab-body {
    height: calc(100vh - 200px);
    overflow-y: scroll;
  }
}
</style>
